module.exports = __webpack_public_path__ + "media/images/front/event_publish_lp/icon_mail_01-f70224a0fff561b6eb0fda39a6ec26e4.png";